<script>
  import { student } from "./../../me.js";
  let campusName = 'Open Campus';
  let today = new Date();

  if(window.location.host == 'portal.fiveislands.uwi.edu'){
    campusName = 'Five Islands Campus';
  }
</script>

<style>
.footer-flag img {
  max-height: 2em;
}
</style>

<div class="col col-md-12 mx-0 pt-5 card-flush">
  <div class="card h-100 py-3 border-0 rounded-top bg-light-transparent">
    <div class="card-body py-2">
      <div class="text-center text-muted mb-2">
        <p>&copy;{today.getFullYear()} The University of the West Indies {campusName}
        <br>
        <a href="/disclaimer">Disclaimer</a> | <a href="/privacy">Privacy Statement</a>
      </p>

      </div>

      <div class="text-center">
        <a class="btn btn-sm footer-flag" href="http://www.uwi.edu/anguilla.asp"><img src="/goto/jellyfish/flags/AI.png" title="Anguilla" ></a>
        <a class="btn btn-sm footer-flag" href="http://www.uwi.edu/antigua.asp"><img src="/goto/jellyfish/flags/AG.png" title="Antigua &amp; Barbuda" ></a>
        <a class="btn btn-sm footer-flag" href="http://www.uwi.edu/bahamas.asp"><img src="/goto/jellyfish/flags/BS.png" title="The Bahamas"></a>
        <a class="btn btn-sm footer-flag" href="http://www.uwi.edu/barbados.asp"><img src="/goto/jellyfish/flags/BB.png" title="Barbados" ></a>
        <a class="btn btn-sm footer-flag" href="http://www.uwi.edu/belize.asp"><img src="/goto/jellyfish/flags/BZ.png" title="Belize" ></a>
        <a class="btn btn-sm footer-flag" href="http://www.uwi.edu/bermuda.asp"><img src="/goto/jellyfish/flags/BM.png" title="Bermuda" ></a>
        <a class="btn btn-sm footer-flag" href="http://www.uwi.edu/bvi.asp"><img src="/goto/jellyfish/flags/VG.png" title="British Virgin Islands" ></a>
        <a class="btn btn-sm footer-flag" href="http://www.uwi.edu/cayman.asp"><img src="/goto/jellyfish/flags/KY.png" title="Cayman Islands" ></a>
        <a class="btn btn-sm footer-flag" href="http://www.uwi.edu/dominica.asp"><img src="/goto/jellyfish/flags/DM.png" title="Dominica" ></a>
        <a class="btn btn-sm footer-flag" href="http://www.uwi.edu/grenada.asp"><img src="/goto/jellyfish/flags/GD.png" title="Grenada" ></a>
        <a class="btn btn-sm footer-flag" href="http://www.uwi.edu/jamaica.asp"><img src="/goto/jellyfish/flags/JM.png" title="Jamaica" ></a>
        <a class="btn btn-sm footer-flag" href="http://www.uwi.edu/montserrat.asp"><img src="/goto/jellyfish/flags/MS.png" title="Montserrat" ></a>
        <a class="btn btn-sm footer-flag" href="http://www.uwi.edu/stkitts.asp"><img src="/goto/jellyfish/flags/KN.png" title="St Kitts and Nevis" ></a>
        <a class="btn btn-sm footer-flag" href="http://www.uwi.edu/stlucia.asp"><img src="/goto/jellyfish/flags/LC.png" title="Saint Lucia" ></a>
        <a class="btn btn-sm footer-flag" href="http://www.uwi.edu/stvincent.asp"><img src="/goto/jellyfish/flags/VC.png" title="St Vincent and the Grenadines" ></a>
        <a class="btn btn-sm footer-flag" href="http://www.uwi.edu/tt.asp"><img src="/goto/jellyfish/flags/TT.png" title="Trinidad and Tobago" ></a>
        <a class="btn btn-sm footer-flag" href="http://www.uwi.edu/turks.asp"><img src="/goto/jellyfish/flags/TC.png" title="Turks and Caicos" ></a>


      </div>
    </div>
  </div>
</div>
